import merge from 'lodash/merge';
import {
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import ReactApexChart, { BaseOptionChart } from '../../components/chart';


export default function AverageSalaryChart ({application, amount, detailIndex, inModal=false}) {
  const theme = useTheme();
  const smUp = useResponsive('up', 'sm');
  const isBig = smUp && !inModal;

  if (detailIndex === undefined || detailIndex < 0) return ( <></> );

  const detail = amount?.details?.[detailIndex];

  const firstData = amount?.details?.map((d) => d.amount_10_15);
  const secondData = amount?.details?.map((d) => d.amount_16_20);

  const labelColors = [theme.palette.text.disabled, theme.palette.text.disabled, theme.palette.text.disabled];
  labelColors[detailIndex] = theme.palette.text.primary;

  const CHART_DATA = [
    {
      type: 'column',
      name: '10~15시간 근무',
      data: firstData
    },
    {
      type: 'column',
      name: '15~20시간 근무',
      data: secondData
    },
  ];

  const MO_CHART_DATA = [
    {
      type: 'column',
      name: '10~15시간 근무',
      data: [detail?.amount_10_15 || 0],
    },
    {
      type: 'column',
      name: '15~20시간 근무',
      data: [detail?.amount_16_20 || 0],
    },
  ]

  const chartOptions = merge(BaseOptionChart(), {
    colors: [
      theme.palette.chart.blue[0],
      theme.palette.chart.violet[0],
    ],


    chart: {
      type: 'bar',
      stacked: false,
      background: theme.palette.grey[100],
      zoom: {
        enabled: false,
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '60%',
        horizontal: false,
        borderRadius: 0,
        dataLabels: {
          position: 'bottom',
          enabled: true,
          offsetX: 0,
          offsetY: 0,
        },
      },
    },
    yaxis: {
      tickAmount: (amount?.chart_max - 50) / 50,
      min: 50,
      max: amount?.chart_max,
      labels: {
        maxWidth: 100,
        formatter: (value) => {
          return `${value}만원`;
        }
      }
    },
    xaxis: {
      type: 'string',
      offsetY: isBig ? 10 : 5,
      categories: isBig ? ['1~3년차', '4~7년차', '8년차+'] : [detail?.label || ''],
      labels: {
        show: true,
        style: {
          colors: isBig ? labelColors : [theme.palette.text.primary],
          fontWeight: 600,
        }
      }
    },
    toolbar: {
      show: false
    },
    tooltip: {
      shared: false,
      intersect: true,
      theme: 'dark',
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}만원`;
          }
          return y;
        },
      },
    },
    dataLabels: {
      position: 'bottom',
      enabled: true,
      offsetX: 0,
      offsetY: 0,
      formatter: function(val, opt) {
        return `${val}만원`
      },
      style: {
        fontWeight: 600,
      }
    },
    stroke: {
      colors: ["transparent"],
      width: 10,
    },
    legend: {
      markers: {
        offsetX: -4,
      },
      labels: {
        colors: theme.palette.text.disabled,
      }
    },
    responsive: [
      {
        // sm
        breakpoint: theme.breakpoints.values.sm,
        options: {
          plotOptions: { bar: { columnWidth: '70%' } },
        },
      },
      {
        // md
        breakpoint: theme.breakpoints.values.md,
        options: {
          plotOptions: { bar: { columnWidth: '80%' } },
        },
      },
    ],
  });

  return (
    <Stack sx={{ my: 3 }}>
      <Typography sx={{ mb: {xs: 1.5, sm: 3 }}}>
        크루님은 <b>'{application?.get_position_display} {detail?.label}'</b> 평균 계약 금액 테이블을 참고할 수 있어요.
      </Typography>
      <Box sx={{ pt: 2, background: theme.palette.grey[100] }}>
        <ReactApexChart type="bar" series={isBig ? CHART_DATA : MO_CHART_DATA} options={chartOptions} height={isBig ? 360 : 280} />
      </Box>
    </Stack>
  );
}
